import { FormattedMessage } from 'react-intl'
import Text from 'components/shared/Text'
import Info from 'components/shared/Info'
import {
    BirthdayPromotionCodeBox,
    BirthdayPromotionCodeButton,
    BirthdayPromotionCodeContent,
} from './styles'
import { darkMode } from 'styles/theme'
import Icon from 'components/shared/Icon'
import { useEffect, useState } from 'react'

const BirthdayPromotionCode = () => {
    const TEXT_TO_CLIPBOARD = 'URODZINY'
    const [isCopied, setIsCopied] = useState(false)
    let timeoutId: NodeJS.Timeout

    useEffect(() => () => clearTimeout(timeoutId), [])

    const handleCopyToClipboard = async () => {
        try {
            // eslint-disable-next-line
            await navigator.clipboard.writeText(TEXT_TO_CLIPBOARD)
            setIsCopied(true)
            clearTimeout(timeoutId)

            timeoutId = setTimeout(() => {
                setIsCopied(false)
            }, 5000)
        } catch (err) {
            console.error('Failed to copy: ', err)
        }
    }

    const PromoCodeInfo = (
        <Text variant="bodySmall" color="grayscale_700">
            <FormattedMessage
                id="promo.birthday.promotion_code"
                defaultMessage="Skorzystaj z kodu <span>URODZINY</span>"
                description="Keep the html tags in the translation"
                values={{
                    span: (chunks: string[]) => (
                        <>
                            <Text
                                as="span"
                                variant="bodyExtraSmallStrong"
                                color="grayscale_900"
                            >
                                {chunks}
                            </Text>
                        </>
                    ),
                }}
            />
        </Text>
    )

    const ClipBoardText = (
        <Text variant="bodySmall" color="grayscale_700">
            <FormattedMessage
                id="promo.birthday.promotion_code_success"
                defaultMessage="Skopiowano pomyślnie!"
                description="Keep the html tags in the translation"
            />
        </Text>
    )

    return (
        <BirthdayPromotionCodeBox isFullWidth mb={24} align="center">
            <Info
                color="info"
                hasNoBackground
                hasBorder
                theme={darkMode}
                align="center"
            >
                <BirthdayPromotionCodeContent
                    isFullWidth
                    direction="row"
                    align="center"
                    gap={[4, 8]}
                >
                    {isCopied ? (
                        ClipBoardText
                    ) : (
                        <>
                            {PromoCodeInfo}
                            <BirthdayPromotionCodeButton
                                onClick={handleCopyToClipboard}
                            >
                                <Icon variant="copy" />
                            </BirthdayPromotionCodeButton>
                        </>
                    )}
                </BirthdayPromotionCodeContent>
            </Info>
        </BirthdayPromotionCodeBox>
    )
}

export default BirthdayPromotionCode
